import Superform from "./Superform";
export default Superform;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/